import styled from "styled-components";
import {
	DESKTOP_M_BP,
	MOBILE_L_BP,
	COLOR_LIGHT_GREEN,
	COLOR_DARK_GREEN_BUTTON,
	FONT_WT_MEDIUM,
	COLOR_WHITE,
	COLOR_TEXT_PRIMARY_B2C,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const StudentHeroWrapper = styled.div`
	padding: 120px 110px 40px 110px;
	.container {
		display: flex;
		flex-flow: wrap;
		.image {
			margin-left: auto;
			margin-right: auto;
			width: 515px;
			height: 515px;
			margin-left: auto;
			background-color: ${COLOR_LIGHT_GREEN};
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.content {
			margin-left: auto;
			margin-right: auto;
			margin-top: 60px;
			.courseTrack {
				display: inline-block;
				padding: 5px 15px 5px 15px;
				background-color: var(--primary-forest-600);
				text-align: center;
				font-size: 16px;
				font-weight: ${FONT_WT_MEDIUM};
				font-stretch: normal;
				font-style: normal;
				line-height: 1.5;
				letter-spacing: normal;
				color: ${COLOR_WHITE};
			}
			.heading {
				width: 321px;
				font-size: 36px;
				font-weight: ${FONT_WT_MEDIUM};
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				color: ${COLOR_TEXT_PRIMARY_B2C};
				margin-top: 25px;
				margin-bottom: 15px;
			}
			.jobDesignation {
				font-size: 16px;
				line-height: 24px;
				font-weight: ${FONT_WT_LIGHT};
				color: ${COLOR_TEXT_PRIMARY_B2C};
				margin-top: 15px;
				margin-bottom: 15px;
				display: flex;
				.designationTitle {
					min-width: 144px;
					font-weight: ${FONT_WT_MEDIUM};
				}
				.designation {
					padding-left: 20px;
					max-width: 300px;
				}
			}
			.testimonial {
				width: 426px;
				font-size: 22px;
				font-weight: ${FONT_WT_LIGHT};
				line-height: 1.27;
				color: ${COLOR_TEXT_PRIMARY_B2C};
				border-left: thick solid var(--primary-forest-600);
				padding-left: 14px;
				margin-top: 40px;
			}
		}
	}
	.testimonialTab {
		display: none;
	}

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		padding: 35px 30px;
		padding-top: 120px;
		.testimonialTab {
			display: block;
		}
		.content {
			margin-top: 0px !important;
			margin-left: unset !important;
			.testimonial {
				display: none;
			}
		}
		.image {
			width: 284px !important;
			height: 284px !important;
			img {
				width: 219px;
				height: 219px;
			}
		}
		.testimonialTab {
			font-size: 20px;
			font-weight: ${FONT_WT_LIGHT};
			line-height: 1.4;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			border-left: thick solid ${COLOR_DARK_GREEN_BUTTON};
			padding-left: 14px;
			margin-top: 30px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 20px;
		padding-top: 70px;
		.container {
			.image {
				width: 100% !important;
				margin-top: 15px;
			}
			.content {
				.heading {
					font-size: 28px;
					width: unset;
				}
			}
		}
		.testimonialTab {
			line-height: 1.25;
		}
	}
`;
